import React, { useState } from 'react';
import { DocumentationFile } from '../../../../graphql/graphql';
import styles from './MultiMediaViewerItem.module.scss';
import { prepareDocumentationFileForMediaViewer } from '../../../ECard/Services/eCardFile.service';
import MediaViewerModal from '../../../Utils/MediaViewer/MediaViewerModal';
import { useAppContext } from '../../../../Services/AppContext';
import { DocumentationFileAntivirusResult } from '../../../Documentation/Enums/DocumentationFileAntivirusResult.enum';
import Loading from '../../../BaseModule/Components/Loading';
import Text from '../../../BaseModule/Components/Text';
import Checkbox from '../../../BaseModule/Components/Checkbox/Checkbox';

interface Props {
	file: DocumentationFile;
	isSelectionMode: boolean;
	isSelected: boolean;
	onSelect: (item: DocumentationFile, isSelected: boolean) => void;
}

const MultiMediaViewerItem: React.FC<Props> = ({
	file,
	isSelectionMode = false,
	isSelected,
	onSelect,
}) => {
	const { socketUrl } = useAppContext();
	const [isMediaViewerOpen, setIsMediaViewerOpen] = useState(false);

	const handleItemClick = () => {
		if (isSelectionMode) {
			onSelect(file, !isSelected);
		} else {
			setIsMediaViewerOpen(true);
		}
	};

	if (!file.thumbUrl) {
		return <></>;
	}

	switch (file.avResult) {
		case DocumentationFileAntivirusResult.UNPROCESSED:
			return <Loading purple />;
		case DocumentationFileAntivirusResult.INFECTED:
			return <Text tx='base.shared.fileDidntPassAntivirus' />;
		case DocumentationFileAntivirusResult.CLEAN:
			return (
				<div className={styles.wrapper}>
					{isSelectionMode && (
						<Checkbox value={isSelected} className={styles.checkbox} />
					)}
					<img
						className={styles.image}
						src={file.thumbUrl}
						onClick={handleItemClick}
					/>
					{isMediaViewerOpen && (
						<MediaViewerModal
							file={prepareDocumentationFileForMediaViewer(file, socketUrl)}
							onClose={() => setIsMediaViewerOpen(false)}
							opened
						/>
					)}
				</div>
			);
	}
};

export default MultiMediaViewerItem;
